import { updateAnalysisView } from "@actions";
import DataGrid from "@shared/DataGrid";
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Tab } from "semantic-ui-react";
import { Dimmer, Loader } from "semantic-ui-react";
import AnalysisGraph from "./AnalysisGraph";

const AnalysisDetailsTable = () => {
  const { details, detailsLoading } = useSelector(
    (state) => state.analysisView,
  );
  return (
    <div style={{ minHeight: "300px" }}>
      <DataGrid
        loading={detailsLoading}
        headings={details.headerDef}
        data={details.data}
        rowDef={details.rowDef}
        className="h-100"
      />
      <Dimmer inverted active={detailsLoading}>
        <Loader active={detailsLoading} />
      </Dimmer>
    </div>
  );
};

const AnalysisTabs = (props) => {
  const { activeTab, dataGroups, selectedDataGroup, selectedTimeGroupBy, timeGroupBy } = props.analysis;
  const { updateAnalysisView } = props;
  const selectedDataGroupObject = dataGroups.find(
    (x) => x.id === selectedDataGroup,
  );
  
  const { displayHours } = timeGroupBy.find((x) => x.id === selectedTimeGroupBy) || {
    displayHours: false,
  };
  const isHourSelected = displayHours;

  const panes = [];

  if (selectedDataGroupObject?.name !== "Asset" && !isHourSelected) {
    panes.push({
      menuItem: "Details",
      pane: (
        <Tab.Pane>
          <AnalysisDetailsTable />
        </Tab.Pane>
      ),
    });
  }

  panes.push({
    menuItem: "Graph",
    pane: (
      <Tab.Pane>
        <AnalysisGraph />
      </Tab.Pane>
    ),
  });

  useEffect(() => {
    if (isHourSelected && activeTab !== 0) {
      updateAnalysisView({ activeTab: 0 });
    }
  }, [isHourSelected, activeTab, updateAnalysisView]);

  return (
    <Tab
      activeIndex={activeTab}
      onTabChange={(e, data) =>
        updateAnalysisView({ activeTab: data.activeIndex })
      }
      renderActiveOnly={false}
      panes={panes}
      className="flex-shrink gs-flex-container-vertical"
    />
  );
};

const mapStateToProps = (state) => {
  return {
    analysis: state.analysisView,
  };
};

export default connect(mapStateToProps, {
  updateAnalysisView,
})(AnalysisTabs);
